module.exports = __webpack_public_path__ + "img/rectangle_male_disable.87bbb09d.svg";